// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"fa3e52bb","389":"81d15014","453":"d7446e4a","895":"42c0c586"}[chunkId] + ".chunk.js";
};